var SeoContent = /** @class */ (function () {
    function SeoContent() {
    }
    SeoContent.removeSeoContent = function () {
        var seoPrefaceContent = document.querySelector(this.seoPrefaceContentSelector);
        if (seoPrefaceContent) {
            var height = SeoContent.outerHeight(seoPrefaceContent);
            var scrollY = window.scrollY;
            seoPrefaceContent.parentElement.removeChild(seoPrefaceContent);
            var scrollPosition = scrollY - height;
            window.scrollTo(0, scrollPosition);
            var seoContent = document.querySelectorAll(this.seoContentSelector);
            if (seoContent) {
                seoContent.forEach(function (element) {
                    element.parentElement.removeChild(element);
                });
            }
        }
    };
    SeoContent.outerHeight = function (element) {
        var height = element.offsetHeight, style = window.getComputedStyle(element);
        return ['top', 'bottom']
            .map(function (side) { return parseInt(style["margin-".concat(side)]); })
            .reduce(function (total, side) { return total + side; }, height);
    };
    SeoContent.seoPrefaceContentSelector = '.seo-content.seo-preface';
    SeoContent.seoContentSelector = '.seo-content';
    return SeoContent;
}());
export default SeoContent;
